import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  imageStyle: {
    height: 40,
    width: 47,
  },
  itemText: {
    textAlign: 'left',
    marginBottom: 5,
  },
  textContainer: {marginHorizontal: 10, flex: 1},
  subText: {
    textAlign: 'left',
  },
  flexStyle: {
    flex: 1,
  },
});
